import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ConfigProvider } from "antd";

import { AuthProvider } from "./context/AuthContext";
import { LoaderProvider, useLoader } from "./context/LoaderContext";

import ProtectedRoute from "./utils/ProtectedRoute";
import Layout from "./components/Layout";
import Loader from "./components/Loader";

import Login from "./pages/Auth/Login";
import Dashboard from "./pages/Dashboard";
import ResetPassword from "./pages/Auth/ResetPassword";
import Forgotpassword from "./pages/Auth/forgotpassword";

import UserManager from "./pages/UserManager/UserManager";
import ClubManager from "./pages/ClubManager/clubmanager";
import AttackDefenceManager from "./pages/AttackManager/AttackManager";
import TrainingComponentManager from "./pages/TrainingManager/TrainingManager";
import SubscriptionPriceManager from "./pages/PriceManager/PriceManager";
import SubscriptionTransactionManager from "./pages/PriceManager/Transaction";
import ContentManager from "./pages/ContentManager/ContentManager";
import EmailTemplateManager from "./pages/EmailManager/EmailManager";
import ExerciseContentManager from "./pages/ExerciseManager/ExerciseManager";
import DidacticsPedagogyContentManager from "./pages/DidacticsManager/DidacticsManager";
import NotificationManager from "./pages/NotificationManager/notificationManager";
import ThemeManager from "./pages/ThemeManager/Thememanager";
import ThemeComponentManager from "./pages/ThemeManager/ThemeComponent";
import UserDetails from "./pages/UserManager/UserDetails";
import ThemeDetails from "./pages/ThemeManager/ThemeDetails";
import ThemeComponentDetails from "./pages/ThemeManager/ThemeComponentDetails";
import ExerciseDetails from "./pages/ExerciseManager/ExerciseDetails";
import ClubDetails from "./pages/ClubManager/ClubDetails";
import DidacticsPedagogyDetails from "./pages/DidacticsManager/DidacticsPedagogyDetails";
import SubscriptionPriceDetails from "./pages/PriceManager/SubscriptionPriceDetails";
import SubscriptionTransactionDetails from "./pages/PriceManager/SubscriptionTransactionDetails";
import NewPaidUsersSimple from "./pages/UserManager/LastPaiduser";
import NotificationDetails from "./pages/NotificationManager/NotificationDetails";
import ContentDetails from "./pages/ContentManager/ContentDetails";
import EmailTemplateDetails from "./pages/EmailManager/EmailTemplateDetails";
import UserSessions from "./pages/UserSession/UserSession";
import TipManager from "./pages/TipManager/TipManager";
import TipDetailView from "./pages/TipManager/TipDetailView";
import PublicContentPage from "./pages/ContentManager/PublicContentPage";
import ClubMigrateManager from "./pages/ClubMigrate/ClubMigrateManager";
import ClubMigrateDetails from "./pages/ClubMigrate/ClubMigrateDetails";

import "./global.css";
import "./responsive.css";

const theme = {
  token: {
    colorPrimary: "#066744",
    colorBgContainer: "#ffffff",
    colorText: "#000000",
    colorBorder: "#d9d9d9",
    borderRadius: 6,
  },
};

function App() {
  return (
    <ConfigProvider theme={theme}>
      <AuthProvider>
        <LoaderProvider>
          <Router>
            <AppWithLoader />
          </Router>
        </LoaderProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

function AppWithLoader() {
  const { loading } = useLoader();

  return (
    <>
      {loading && <Loader />}

      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/reset_password/:token" element={<ResetPassword />} />
        <Route path="/forgot-password" element={<Forgotpassword />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/exercise"
          element={
            <ProtectedRoute>
              <Layout>
                <ExerciseContentManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/exercises/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ExerciseDetails />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/theme"
          element={
            <ProtectedRoute>
              <Layout>
                <ThemeManager />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/themes/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ThemeDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/themecomponent"
          element={
            <ProtectedRoute>
              <Layout>
                <ThemeComponentManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/themecomponent/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ThemeComponentDetails />
              </Layout>
            </ProtectedRoute>
          }
        />
        {/* <Route path="/theme-component/details/:id" element={<ThemeComponentDetails />} /> */}
        <Route
          path="/attackdefense"
          element={
            <ProtectedRoute>
              <Layout>
                <AttackDefenceManager />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/emailtemplate"
          element={
            <ProtectedRoute>
              <Layout>
                <EmailTemplateManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="email-templates/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <EmailTemplateDetails />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/content"
          element={
            <ProtectedRoute>
              <Layout>
                <ContentManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/content/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ContentDetails />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/notification"
          element={
            <ProtectedRoute>
              <Layout>
                <NotificationManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifications/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <NotificationDetails />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/subscriptiontransaction"
          element={
            <ProtectedRoute>
              <Layout>
                <SubscriptionTransactionManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscription-transactions/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <SubscriptionTransactionDetails />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/subscriptionprice"
          element={
            <ProtectedRoute>
              <Layout>
                <SubscriptionPriceManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/exercises/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ExerciseDetails />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/subscription-prices/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <SubscriptionPriceDetails />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/didactics"
          element={
            <ProtectedRoute>
              <Layout>
                <DidacticsPedagogyContentManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/didactics/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <DidacticsPedagogyDetails />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Layout>
                <UserManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <UserDetails />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/clubs"
          element={
            <ProtectedRoute>
              <Layout>
                <ClubManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/clubs/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ClubDetails />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/trainingcomponents"
          element={
            <ProtectedRoute>
              <Layout>
                <TrainingComponentManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/new-paid-users"
          element={
            <ProtectedRoute>
              <Layout>
                <NewPaidUsersSimple />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/user-sessions"
          element={
            <ProtectedRoute>
              <Layout>
                <UserSessions />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/tip-sessions"
          element={
            <ProtectedRoute>
              <Layout>
                <TipManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/tips/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <TipDetailView />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/club-migrate"
          element={
            <ProtectedRoute>
              <Layout>
                <ClubMigrateManager />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/clubmigrate/details/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ClubMigrateDetails />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route
          path="/terms"
          element={<PublicContentPage slug="terms_conditions" title="Terms" />}
        />

        <Route
          path="/privacy"
          element={
            <PublicContentPage slug="privacy_policy" title="Privacy Policy" />
          }
        />
      </Routes>
    </>
  );
}

export default App;
